import { useState } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import HowItWorksSection from "@/components/HowItWorksSection";
import WhyChooseSection from "@/components/WhyChooseSection";
import ServiceAreaSection from "@/components/ServiceAreaSection";
import CTASection from "@/components/CTASection";
import ContactSection from "@/components/ContactSection";
import QuoteFormModal from "@/components/QuoteFormModal";

const LandingPage = () => {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  const openQuoteModal = () => setIsQuoteModalOpen(true);
  const closeQuoteModal = () => setIsQuoteModalOpen(false);

  return (
    <div className="min-h-screen" data-testid="landing-page">
      <Header onBookClick={openQuoteModal} />
      
      <main>
        <HeroSection onBookClick={openQuoteModal} onQuoteClick={openQuoteModal} />
        <ServicesSection />
        <HowItWorksSection />
        <WhyChooseSection />
        <ServiceAreaSection />
        <CTASection onBookClick={openQuoteModal} />
        <ContactSection />
      </main>

      <Footer />

      <QuoteFormModal isOpen={isQuoteModalOpen} onClose={closeQuoteModal} />
    </div>
  );
};

export default LandingPage;
